<template>
  <div class="discussPage">
    <Header></Header>
    <div class="bannerWrap">
      <div class="mainTit">服务详情</div>
      <div class="sunTit">/ Service Details</div>
    </div>
    <div class="content">
      <div style="font-size: 16px;">
        <div style="margin-bottom: 16px;">
          <span style="color: #ABB8C9;">
            <span class="goBackPage" @click="goBackPage(1)">首页</span> > 
            <span class="goBackPage" @click="goBackPage(2)">
              <template v-if="type ===1 ">
                需求大厅
              </template>
              <template v-if="type ===2 ">
                服务大厅
              </template> 
            </span> > 
            <span class="serviceTest">服务详情</span>
          </span>
        </div>
      </div>
      <div class="title">
        {{pageData.name}}
      </div>
      <div class="contentinfo">
        <div>
          <div>
            <span class="name">服务行业：</span>
            <span>{{pageData.categoryName}}</span>
          </div>
          <div>
            <span class="name">联系电话：</span>
            <span>{{pageData.phone}}</span>
          </div>
          <div>
            <span class="name">联系人：</span>
            <span>{{pageData.contacts}}</span>
          </div>
          <div>
            <span class="name">企业名称：</span>
            <span>{{pageData.enterpriseName}}</span>
          </div>
          <div>
            <span class="name">预算（元）：</span>
            <span>{{pageData.budget == 0 ? '协商' : pageData.budget }}</span>
          </div>
          <div style="width: 100%">
            <span class="name">服务详情：</span>
            <span>{{pageData.details}}</span>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div>
        <div><span class="pl">评论 </span><span class="num">{{total}}</span></div>
        <div class="comment">
          <img src="../../assets/images/-s-mrtx.png" width="50px" height="50px"
            style="border-radius: 50%;margin-right: 20px;">
          <el-input type="textarea" placeholder="来说两句吧" v-model="textarea" maxlength="300" show-word-limit :rows="5">
          </el-input>
        </div>
        <div class="btn">
          <div class="submitPL" @click="subPL">发表评论</div>
        </div>

      </div>

      <div class="pinglunlist" v-for="(item, index) in LeavList" :key="index">
        <div class="commentList">
          <img :src="item.userLogo ? baseUrl + item.userLogo : require('../../assets/images/-s-mrtx.png')" width="50px" height="50px"
            style="border-radius: 50%;margin-right: 20px;">
          <div>
            <span class="name">{{item.username ? item.username : '---'}}</span> <span class="date">{{item.createTime}}</span>
          </div>
        </div>
        <div class="pinglun">
          {{item.message}}
        </div>
      </div>
      <Paging @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :currentPage="pageNum"
        :loading="loading" :pageSize="pageSize" :total="total"></Paging>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Paging from "@/components/common/commonTable";
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    supplyDemandById,
    reserve,
    reserveMessageList
  } from '@/api/api'
  import {
    categoryList
  } from '@/api/api'
  export default {
    data() {
      return {
        baseUrl: serverUrl.baseURL,
        textarea: '',
        pageData: {},
        LeavList: {},
        pageNum: 0,
        pageSize: 10,
        loading: false,
        total: 0,

        type: 0, // 1需求大厅 2服务大厅
      }
    },
    components: {
      Header,
      Footer,
      Paging
    },
    mounted() {
      this.id = this.$route.query.data
      this.type = parseInt(this.$route.query.type)
      this.setSupplyDemandById()
      this.getReserveMessageList()
    },
    methods: {
      goBackPage(val) {
        if (val == 1) {
          this.$router.push({
              path: '/Home'
           })
        }else if(val == 2) {
          this.$router.push({
              name: 'Discuss',
              params: {
                type: this.type
              }
           })
        }

      },
      //当前页变更
      handleCurrentChange(num) {
        this.pageNum = num
        this.getpolicyList();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.currentPage = 1;
        this.getpolicyList();
      },
      getReserveMessageList() {
        let params = {
          supplyDemandId: this.id,
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize
        }
        reserveMessageList(params).then(res=> {
          this.LeavList = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      setSupplyDemandById() {
        supplyDemandById({
          id: this.id
        }).then(res => {
          this.pageData = res.data
        })
      },
      subPL() {
        if (!this.textarea) {
          return this.$message({
            message: '请输入评论内容!',
            type: 'warning'
          });
        }
        reserve({
          supplyDemandId: this.id,
          message: this.textarea
        }).then(res => {
          this.getReserveMessageList()
          if(res.code == 1) {
            this.$message({
              message: '评论成功！',
              type: 'success'
            });
          }else {
            if(res.code == 0) {
              this.$message.error('评论失败，请重试')
            }
          }

          this.textarea = ''
        })
      }
    }
  }
</script>

<style scoped>
  .bannerWrap {
    width: 100%;
    height: 480px;
    background: url('../../assets/images/discussBanner.png') top center no-repeat;
    background-size: 100% 100%;
    padding: 265px 0 0 60px;
    box-sizing: border-box;
  }

  .mainTit {
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 44px;
  }

  .sunTit {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }

  .content {
    width: 1300px;
    margin: 40px auto;
  }

  .title {
    width: 1222px;
    height: 70px;
    line-height: 70px;
    background: linear-gradient(90deg, #E9EFFF, #FFFFFF);
    border-radius: 10px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
    padding-left: 30px;
  }

  .contentinfo {
    /* display: flex; */
    width: 100%;
    padding: 20px;
  }

  .contentinfo>div>div {
    padding: 10px 0;
    display: inline-block;
    width: 33%;
    color: #121E30;
  }

  .name {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
  }

  .line {
    width: 1271px;
    height: 0px;
    border: 1px dashed #C8D0E4;
    margin: 40px auto;
  }

  .comment {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
  }

  textarea {
    height: 50px;
  }

  .commentList {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* align-items: baseline; */
  }

  .pinglun {
    margin-left: 70px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 28px;
  }

  .pinglunlist {
    margin-top: 20px;
  }

  .name {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
    line-height: 21px;
  }

  .date {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 28px;
    display: inline-block;
    margin-left: 10px;
  }

  .pl {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
  }

  .num {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #A6B4C8;
  }

  .btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .submitPL {
    width: 118px;
    height: 46px;
    background: #0F5EFF;
    border-radius: 23px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    line-height: 46px;
  }

  .serviceTest {
    color: #1A2435;
  }

  .goBackPage {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/platform/DiscussDetails.vue